import React, { useState, useEffect } from 'react';
import { Form, Button, Card, Alert, InputGroup } from 'react-bootstrap';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import Swal from 'sweetalert2';
import ImageCropper from '../Utils/ImageCropper';
import PhoneInput from '../Input/PhoneInput';
import { useProvider, Toast } from '../../context/MenuProvider';

const ConsultorForm = () => {
  const { id, prospecto, retorno } = useParams();
  const [query, setQuery] = useState('');
  const navigate = useNavigate();
  const [uplines, setUplines] = useState([]);
  const [prospectos, setProspectos] = useState([]);
  const [consultor, setConsultor] = useState(null);
  const [formErrors, setFormErrors] = useState({});

  const {
    crudAdmin,
    userAdmin,
    salvarDados,
    setLinks,
    setBtns,
  } = useProvider();
  const { post, patch, del, put, get, loading } = crudAdmin || {};

  const location = useLocation();

  useEffect(() => {
    if (id) {
      carregarConsultor();
    } else {
      setConsultor((item) => ({
        ...item,
        pre_cadastro:true,
        data_cadastro:new Date().toLocaleDateString('sv-SE'),
      }))
    }
  }, [id]);

  useEffect(() => {
    if (query || prospecto) buscarUplines();
  }, [query, prospecto]);
  
  useEffect(() => {
    if ((!prospecto && consultor?.nome) || prospecto) buscarProspectos();
  }, [consultor?.nome, prospecto]);

  useEffect(() => {
    setLinks([]);
    setBtns([
      ...(id ?[{
        icon: 'bi-trash',
        onClick: async (e) => {
          e?.preventDefault();
          await handleDelete();
        },
      }]:[]),
      {
        icon: 'bi-check-lg',
        onClick: async (e) => {
          e.preventDefault();
          await handleSubmit();
        },
      },
    ]);

    return () => {
      setLinks([]);
      setBtns([]);
    };
  }, [setLinks, setBtns, consultor]);

  const carregarConsultor = async () => {
    try {
      const response = await get(`/rede/consultores/${id}/?expand=upline,prospecto`, 'pagina');
      if (response && response.length) {
        const dados = response[0];
        setConsultor(dados);

        const uplineAtual = dados?.upline;
        if (uplineAtual && uplineAtual.id) {
          setQuery(uplineAtual.nome || uplineAtual?.contato?.nome_do_cliente || uplineAtual.codigo);
        }
        if (dados?.upline) {
          setUplines([dados?.upline]);
        }
        if (dados?.prospecto) {
          setProspectos([dados?.prospecto]);
        }
      }
    } catch (err) {
      console.error(err);
    }
  };

  const buscarUplines = async () => {
    try {
      const response = await get(`/rede/consultores/?expand=upline&search=${query}`, 'upline');
      if (response && response.length) {
        setUplines(prev => {
          const uplineAtualId = consultor?.upline?.id;
          let novosUplines = response[0].results.filter(item => item.id != null);

          // Garante que o upline atual esteja na lista
          if (uplineAtualId && !novosUplines.some(item => item.id === uplineAtualId)) {
            const atual = prev.find(item => item.id === uplineAtualId);
            if (atual) novosUplines.push(atual);
          }

          return novosUplines;
        });
      }
    } catch (err) {
      console.error(err);
    }
  };
  
  const buscarProspectos = async () => {
    try {
      const response = await get(`/rede/prospectos/?ordering=contato__nome${(prospecto)?`&ids=${prospecto}`:''}${consultor?.nome?`&search=${consultor?.nome}`:''}`, 'prospectos');
      if (response && response.length) {
        setProspectos(prev => {
          const itemAtualId = consultor?.contato?.id;
          let novosItens = response[0].results.filter(item => item.id != null);

          // Garante que o upline atual esteja na lista
          if (itemAtualId && !novosItens.some(item => item.id === itemAtualId)) {
            const atual = prev.find(item => item.id === itemAtualId);
            if (atual) novosItens.push(atual);
          }
          return novosItens;
        });
        if(prospecto){
            const item = response[0].results.find(item => parseInt(item.id) === parseInt(prospecto));
            setConsultor((prev)=>({
              ...prev,
              prospecto:item
            }))
        }
      }
    } catch (err) {
      console.error(err);
    }
  };

  
  const handleDelete = async (e) => {
    if (e) e.preventDefault();
    
    Swal.fire({
        title: "Excluir Consultor da equipe?",
        text: `Ao excluir definitivamente ${consultor?.contato?.nome_do_cliente || consultor?.nome} da equipe, os downlines diretos subirão para o próximo upline.`,
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim!",
        cancelButtonText: "Não"
    }).then(async(result) => {
        if(result.isConfirmed){
          try{
            await del(`/rede/consultores/${id}/`);
            Toast.fire({
              icon: 'success',
              title: 'Consultor excluída com sucesso',
            });
            navigate(-1);
          }catch(err){
            Toast.fire({
              icon: 'warning',
              title: 'Falha ao excluir Consultor',
            });
          }finally{
            
          }
        }
    });
  };
  
  const toggleChecarCombo = async () => {
    try {
      Swal.fire({
        title: "Pegou combo?",
        text: `${consultor?.contato?.nome_do_cliente || consultor?.nome} pegou combo para iniciar os trabalhos?`,
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim!",
        cancelButtonText: "Não"
      }).then(async(result) => {
        setConsultor((prev) => ({
          ...prev,
          pre_cadastro:!(!!result.isConfirmed)
        }))
      });
    } catch (err) {
      console.error("Erro ao ativar consultor", err);
    }
  };
  
  

  const handleSubmit = async (e) => {
    if (e) e.preventDefault();

    const errors = {};
    if (!consultor?.prospecto) errors.nome = 'Por favor, informe um prospecto.';
    if (!consultor?.data_cadastro || consultor.data_cadastro === '') errors.data_cadastro = 'Por favor, informe a data do cadastro.';

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }

    setFormErrors({});

    const formData = new FormData();
    formData.append('nome', consultor?.nome);
    formData.append('data_cadastro', consultor?.data_cadastro);
    formData.append('pre_cadastro', !!consultor?.pre_cadastro);
    formData.append('pre_validade', consultor?.pre_validade || ``);
    formData.append('observacoes', consultor?.observacoes || ``);
    formData.append('upline', consultor?.upline?.id || parseInt(consultor?.upline) || ``);
    formData.append('prospecto', consultor?.prospecto?.id || parseInt(consultor?.prospecto) || ``);
    
    if(!id){
      Swal.fire({
        title: "Pegou combo?",
        text: `${consultor?.prospecto?.contato?.nome_do_cliente || consultor?.nome || consultor?.prospecto?.nome} já pegou o combo para iniciar o trabalho?`,
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim!",
        cancelButtonText: "Não"
      }).then(async(result) => {
        formData.append('pre_cadastro', !(!!result.isConfirmed));
        await salvarEquipe(formData);
      });
    } else {
        formData.append('pre_cadastro', !!consultor?.pre_cadastro);
        await salvarEquipe(formData);
    } 
  };
  
  const salvarEquipe = async (formData) => {
    const apiRequest = id ? patch : post;
    try {
      const response = await apiRequest(
        formData,
        `/rede/consultores/${id || ''}${id ? '/' : ''}?filtros=nome_do_cliente`,
        'multipart/form-data',
        'salvar'
      );

      if (response && response.length) {
        Toast.fire({
          icon: 'success',
          title: 'Consultor salvo com sucesso',
        });
        switch(retorno){
          case `prospectos`:
            navigate(`/rede/prospectos/${response[0].pre_cadastro?'acompanhar':'finalizado'}/`,{replace:true});
            break;
          default:
            navigate(-1);
            break;
        }
      }
    } catch (err) {
      //alert(JSON.stringify(err.response?.data))
      const errorMessage =
        typeof err.response?.data === 'string'
          ? 'Erro ao salvar o cliente.'
          : err.response?.data?.detail;

      setFormErrors(prev => ({
        ...prev,
        apiError: errorMessage,
        telefone: err.response?.data?.telefone,
        documento: err.response?.data?.cpf_cnpj,
        nome: err.response?.data?.nome_do_cliente,
        endereco: err.response?.data?.endereco,
        diaDoAniversario: err.response?.data?.dia_do_aniversario,
        ativo: err.response?.data?.ativo,
        observacoes: err.response?.data?.observacoes,
        crediario: err.response?.data?.crediario,
        regiao: err.response?.data?.regiao,
      }));
    }
  }
  
  // render recursivo
  const renderUplines = (lista, todas, nivel = 0) => {
    return lista.map(item => {
      const filhos = todas.filter(c => c.upline?.id === item.id);

      return (
        <React.Fragment key={item.id}>
          <option value={item.id}>
            {`${'— '.repeat(nivel)}${item?.nome || ''}`}
          </option>
          {renderUplines(filhos, todas, nivel + 1)}
        </React.Fragment>
      );
    });
  };


  return (
    <div>
      <Card>
        <Card.Body>
          <Form onSubmit={handleSubmit}>
            {formErrors.apiError && <Alert variant="danger">{formErrors.apiError}</Alert>}

            <Form.Group controlId="formCategoria" className="mb-3">
              <InputGroup>
                <Form.Control
                  type="text"
                  placeholder="Pesquisar upline..."
                  value={query}
                  onChange={(e) => setQuery(e.target.value)}
                />
                <Button variant="secondary" onClick={() => buscarUplines()}>
                  <i className="bi bi-search"></i>
                </Button>
              </InputGroup>
            </Form.Group>

            <Form.Group controlId="formUpline" className="mt-3">
              <InputGroup>
                <span className="input-group-text">Upline</span>
                <Form.Control
                  as="select"
                  value={consultor?.upline?.id || ''}
                  onChange={(e) =>
                    setConsultor((item) => ({
                      ...item,
                      upline: {
                        ...item.upline,
                        id:e.target.value,
                      }
                    }))
                  }
                >
                  <option value="">{userAdmin?.nome_da_loja} (Eu)</option>
                  {renderUplines(uplines.filter(c => !c.upline), uplines)}
                </Form.Control>
              </InputGroup>
            </Form.Group>

            {(!prospecto && !id) && (
              <Form.Group controlId="formNomeDoConsultor" className="mt-3">
                <InputGroup>
                  <Form.Control
                    type="text"
                    placeholder="Pesquisar prospectos..."
                    value={consultor?.nome}
                    onChange={(e) => setConsultor((prev) => ({ ...prev, nome: e.target.value }))}
                  />
                  <Button variant="secondary" onClick={() => buscarProspectos()}>
                    <i className="bi bi-search"></i>
                  </Button>
                  <Button variant="outline-secondary" onClick={() => navigate(`/rede/prospectos/contatos/`)}>
                    <i className="bi bi-plus"></i>
                  </Button>
                </InputGroup>
              </Form.Group>
            )}
            
            <Form.Group controlId="formContato" className="mt-3">
                <InputGroup>
                  <span className="input-group-text">Prospecto</span>
                  <Form.Control
                    as="select"
                    disabled={!!prospecto || !!id}
                    value={consultor?.prospecto?.id || parseInt(consultor?.prospecto) || prospecto || ''}
                    onChange={(e) =>
                      setConsultor((item) => ({
                        ...item,
                        nome: prospectos.find(c => c.id === parseInt(e.target.value||0))?.nome || item?.nome,
                        prospecto: {
                          ...item?.prospecto, // evita erro se contato for undefined
                          id: e.target.value,
                        },
                      }))
                    }
                  >
                    <option value=""></option>
                    {prospectos.map(item => (
                      <option key={item.id} value={item.id}>
                        {item?.nome}
                      </option>
                    ))}
                  </Form.Control>
                </InputGroup>
                {formErrors.prospecto && <Alert variant="danger">{formErrors.prospecto}</Alert>}
            </Form.Group>

            <Form.Group controlId="formDataCadastro" className="mt-3">
              <InputGroup>
                <span className="input-group-text">Cadastro</span>
                <Form.Control
                  type="date"
                  value={consultor?.data_cadastro || ''}
                  onChange={(e) =>
                    setConsultor((item) => ({
                      ...item,
                      data_cadastro: e.target.value,
                    }))
                  }
                />
              </InputGroup>
              {formErrors.data_cadastro && <Alert variant="danger">{formErrors.nome}</Alert>}
            </Form.Group>
            {id && (<>
              <Form.Group controlId="formPreCadastro" className="mt-2">
                <Form.Check
                  type="switch"
                  label="Pré Cadastro"
                  checked={consultor?.pre_cadastro}
                  onChange={toggleChecarCombo}
                />
                {formErrors.pre_cadastro && (
                  <Alert variant="danger">{formErrors.pre_cadastro}</Alert>
                )}
              </Form.Group>
              <Form.Group controlId="formCadastro" className="mt-2">
                <Form.Check
                  type="switch"
                  label="Cadastro com Combo"
                  checked={!consultor?.pre_cadastro}
                  onChange={toggleChecarCombo}
                />
                {formErrors.pre_cadastro && (
                  <Alert variant="danger">{formErrors.pre_cadastro}</Alert>
                )}
              </Form.Group>
              {consultor?.pre_cadastro && (<>
                <Form.Group controlId="formDataValidade" className="mt-3">
                  <InputGroup>
                    <span className="input-group-text">Expira em</span>
                    <Form.Control
                      type="date"
                      value={consultor?.pre_validade || ''}
                      onChange={(e) =>
                        setConsultor((item) => ({
                          ...item,
                          pre_validade: e.target.value,
                        }))
                      }
                    />
                  </InputGroup>
                </Form.Group>
              </>)}
            </>)}
            <Form.Group controlId="formObservacoes" className="mt-3">
              <Form.Control
                as="textarea"
                value={consultor?.observacoes}
                onChange={(e) => setConsultor((prev)=> ({
                  ...prev,
                  observacoes:e.target.value
                }))}
                placeholder="Observações"
                rows={5}
                style={{ resize: 'none' }}
              />
            </Form.Group>

            <Button variant="secondary" type="submit" className="mt-4 w-100" disabled={loading}>
              Salvar
            </Button>
          </Form>
        </Card.Body>
      </Card>
    </div>
  );
};

export default ConsultorForm;